import Constants from '../Constants.js';
class ApiAccessKey {
  constructor({
    apiAccessKeyId,
    resourceId,
    resourceApi
  }) {
    this.apiAccessKeyId = apiAccessKeyId;
    this.resourceApi = resourceApi;
    this.resourceId = resourceId;
  }
  createAction(method, status, func) {
    return (dispatch, getState, opts) => {
      dispatch({
        type: Constants.API_ACCESS_KEY_STATUS,
        resourceId: this.resourceId,
        apiAccessKeyId: this.apiAccessKeyId,
        status
      });
      const api = this.resourceApi(dispatch, getState, opts, this.resourceId);
      // override top level api with resource api
      return func(dispatch, getState, {
        ...opts,
        api
      }, this.resourceId).catch(error => {
        dispatch({
          type: Constants.API_ACCESS_KEY_STATUS,
          resourceId: this.resourceId,
          apiAccessKeyId: this.apiAccessKeyId,
          status: `${method}Error`,
          error
        });
        return Promise.reject(error);
      });
    };
  }
  get(opts) {
    return this.createAction('get api access key', 'getting api access key', async (dispatch, getState, {
      api
    }, resourceId) => {
      const {
        requestId,
        ...reqOpts
      } = opts || {};
      const r = await api.apiAccessKey(this.apiAccessKeyId).get(reqOpts);
      dispatch({
        type: Constants.API_ACCESS_KEY_GET,
        resourceId,
        apiAccessKey: r,
        requestId
      });
      return r;
    });
  }
  canGet() {
    return async (dispatch, getState, opts) => {
      const api = this.resourceApi(dispatch, getState, opts, this.resourceId);
      const r = await api.apiAccessKey(this.apiAccessKeyId).get({
        test: true
      });
      dispatch({
        type: Constants.ALLOWED_SET,
        resourceId: this.resourceId,
        action: 'getApiAccessKey',
        allowed: r.allowed === true
      });
      return r;
    };
  }
  update(opts) {
    return this.createAction('update api access key', 'updating api access key', async (dispatch, getState, {
      api
    }, resourceId) => {
      const {
        requestId,
        ...reqOpts
      } = opts || {};
      const r = await api.apiAccessKey(this.apiAccessKeyId).update(reqOpts);
      dispatch({
        type: Constants.API_ACCESS_KEY_UPDATE,
        resourceId,
        apiAccessKey: r,
        requestId
      });
      return r;
    });
  }
  canUpdate() {
    return async (dispatch, getState, opts) => {
      const api = this.resourceApi(dispatch, getState, opts, this.resourceId);
      const r = await api.apiAccessKey(this.apiAccessKeyId).update({}, {
        test: true
      });
      dispatch({
        type: Constants.ALLOWED_SET,
        resourceId: this.resourceId,
        action: 'updateApiAccessKey',
        allowed: r.allowed === true
      });
      return r;
    };
  }
  delete(opts) {
    return this.createAction('delete api access key', 'deleting api access key', async (dispatch, getState, {
      api
    }, resourceId) => {
      const {
        requestId,
        ...reqOpts
      } = opts || {};
      const r = await api.apiAccessKey(this.apiAccessKeyId).delete(reqOpts);
      dispatch({
        type: Constants.API_ACCESS_KEY_REMOVE,
        resourceId,
        apiAccessKeyId: r.childId,
        requestId
      });
      return r;
    });
  }
  canDelete() {
    return async (dispatch, getState, opts) => {
      const api = this.resourceApi(dispatch, getState, opts, this.resourceId);
      const r = await api.apiAccessKey(this.apiAccessKeyId).delete({
        test: true
      });
      dispatch({
        type: Constants.ALLOWED_SET,
        resourceId: this.resourceId,
        action: 'deleteApiAccessKey',
        allowed: r.allowed === true
      });
      return r;
    };
  }
}
export default ApiAccessKey;